<template>
	<c-dialog ref="dialog" title="发货单详情" mode="slide" width="100vw-300" enable-flex mask-close :button="false">
		<template #head>
			<div v-if="detailData.deliver_code" class="m-detail-tag flex-center-cross">
				<label>{{detailData.deliver_code}}</label>
			</div>
		</template>
		
		<module>
			<module-col size="350">
				<c-detail class="m-detail-form">
					<c-detail-item label="发货单二维码">
						<c-qrcode :value="detailData.h5_web" size="100"></c-qrcode>
					</c-detail-item>
					<c-detail-item label="客户名称">
						{{detailData.customer_name}}
					</c-detail-item>
					<c-detail-item label="发货仓库">
						{{detailData.warehouse_name}}
					</c-detail-item>
					<c-detail-item label="发货数量">
						{{detailData.deliver_count}}
					</c-detail-item>
					<c-detail-item label="创建人">
						{{detailData.create_user_realname}}
					</c-detail-item>
					<c-detail-item label="创建时间" colspan="2">
						{{detailData.create_date}}
					</c-detail-item>
					<c-detail-item v-if="detailData.orders" label="关联销售单">
						<order-link type="order" :data="detailData.orders"></order-link>
					</c-detail-item>
					<custom-detail work-type="32" :data="detailData.customFieldValues"></custom-detail>
				</c-detail>
			</module-col>

			<module-col tab-type="border-tab">
				<module-tab name="发货明细" enable-flex>
					<div class="m-detail-box">
						<custom-table ref="deliverTable" view-id="20024" height="grow" readonly>
							<template #aux_unit_count_tip="{data}">
								<c-tooltip tip="提示" width="360" align="end">
									<template #tip>
										<p>单位转换倍率说明：</p>
										<p>单位换算率为产品主/辅单位之间的转换倍率，计算公式如下：</p>
										<p>发货数量（辅单位）* 换算率 = 发货产品数量（主单位）</p>
										<p>如：1（kg） * 1000 = 1000（g）</p>
										<p>换算率修改后系统会自动计算发货产品数量</p>
									</template>
								</c-tooltip>
							</template>
						</custom-table>
					</div>
				</module-tab>
				<!--批次明细（仅批次库存模式）-->
				<module-tab name="发货批次明细" enable-flex v-if="systemConfig.batch_stock == 1">
					<div class="m-detail-box">
						<c-table ref="batchTable" height="grow" :paging="false">
							<c-table-column
								label="产品编号"
								width="140"
								name="product_code"
							></c-table-column>
							<c-table-column
								label="产品名称"
								width="160"
								name="product_name"
							></c-table-column>
							<c-table-column
								label="产品规格"
								width="140"
								name="product_spec"
							></c-table-column>
							<c-table-column
								label="批次号"
								width="220"
								name="batch_code"
							></c-table-column>
							<c-table-column
								label="入库时间"
								width="140"
								name="production_date"
							></c-table-column>
							<c-table-column
								label="发货数量"
								width="120"
							>
								<template #default="{data}">
									{{data.qty}}{{data.unit}}
								</template>
							</c-table-column>
							<template #empty>
								<c-empty message="暂无批次明细"></c-empty>
							</template>
						</c-table>
					</div>
				</module-tab>
			</module-col>
		</module>
	</c-dialog>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		name: 'orderDeliverDetail',

		props: {
			id: [String, Number]
		},

		computed: {
			// 获取系统配置
			...mapState(['systemConfig'])
		},
		
		data() {
			return {
				detailData: {}
			}
		},

		methods: {
			open() {
				this.request({
					url: '/order/deliver/detail',
					data: {
						id: this.id
					},
					loading: true,
					success: data => {
						this.detailData = data.detailInfo;
						this.$refs.deliverTable.init();
						this.$refs.deliverTable.$refs.list.setData(data.productList);
						//批次明细（仅批次库存模式渲染该TAB）
						if (this.$refs.batchTable) {
							this.$refs.batchTable.setData(data.batchList || []);
						}
						this.$refs.dialog.open();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>